import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './App.css';

export default function WorkExperience(props) {
    return (
        <>
            <Card className="mobile-hide workExpCard workExpInnerCard">
                <CardActionArea className="row workExpCard">
                    <Avatar className="cardImg">
                    <LazyLoadImage
                    className="cardImg"
                        alt={props.logoAlt}
                        src={props.logo}
                        effect="blur" />
                        </Avatar>
                    <div className="col cardInfo">
                        <Typography>{props.location}</Typography>
                        <Typography>{props.date}</Typography>
                    </div>
                    <div className="col cardDetails">
                        <Typography className="experienceTitle">{props.title}</Typography>
                        <Typography>{props.details}</Typography>
                        <div className="row">
                            {props.tags.map((items) => <Chip className="cardTags" size="small" label={items} key={items} />)}
                        </div>
                    </div>
                </CardActionArea>
            </Card>
            
            <Card className="desktop-hide workExpCard workExpInnerCard">
                <CardActionArea className="col workExpCard">
                    <div className="row">
                    <Avatar className="cardImg">
                    <LazyLoadImage
                    className="cardImg"
                        alt={props.logoAlt}
                        src={props.logo}
                        effect="blur" />
                        </Avatar>
                        <div className="col cardInfo">
                            <Typography>{props.location}</Typography>
                            <Typography>{props.date}</Typography>
                        </div>
                    </div>
                    <div className="col cardDetails">
                        <Typography className="experienceTitle">{props.title}</Typography>
                        <Typography>{props.details}</Typography>
                        <div className="row cardTagsScroll">
                            {props.tags.map((items) => <Chip className="cardTags" size="small" label={items} key={items} />)}
                        </div>
                    </div>
                </CardActionArea>
            </Card>
        </>
    );
}